'use client';
import AppLayout from '@/components/AppLayout';
import ComplianceEventSubscriptions from './components/ComplianceEventSubscriptions';

export default function ComplianceEventSubscriptionsPage() {
  return (
    <AppLayout portalRole="compliance">
      <ComplianceEventSubscriptions />
    </AppLayout>
  );
}
